angular.module('picmonicng').component('homeReferralBlock', {
  templateUrl: '/templates/app/components/home-referral-block/home-referral-block.html',
  bindings: {},
  controller: [
    'UserService',
    'Shares',
    function (UserService, Shares) {
      var ctrl = this;

      ctrl.UserService = UserService;
      ctrl.emailInputFocus = false;
      ctrl.emails = [];
      ctrl.email = '';
      ctrl.emailSent = false;
      ctrl.invalidEmail = false;
      ctrl.showEmailInput = false;
      ctrl.sendingReferrals = false;

      ctrl.handleEmailInputFocus = function () {
        ctrl.emailInputFocus = true;
      };

      ctrl.handleEmailInputBlur = function () {
        ctrl.emailInputFocus = false;
      };

      ctrl.toggleEmailInput = function () {
        ctrl.showEmailInput = !ctrl.showEmailInput;
        ctrl.emailInputFocus = true;
        setTimeout(function () {
          document.getElementById('email-input').focus();
        }, 0);
        send_ga('event', 'Home', 'Email Button Clicked');
      };

      ctrl.addEmail = function () {
        ctrl.emailSent = false; // reset the message when a new email is added
        if (ctrl.email) {
          ctrl.email.split(',').forEach(function (item) {
            if (ctrl.emails.indexOf(item.trim()) === -1 && item.trim() !== '') {
              ctrl.emails.push(item.trim());
            }
          });
          ctrl.email = undefined;
        }
      };

      ctrl.removeEmail = function (email) {
        ctrl.emails = _.without(ctrl.emails, email);
      };

      ctrl.sendReferrals = function () {
        if (!ctrl.sendingReferrals) {
          ctrl.sendingReferrals = true;
          ctrl.emailSent = false;

          const data = {
            type: 'email_referral',
            emails: ctrl.emails,
          };

          Shares.save(
            data,
            function () {
              ctrl.sendingReferrals = false;
              ctrl.emails = [];
              ctrl.emailSent = true;
            },
            function (response) {
              ctrl.sendingReferrals = false;
              ctrl.emailSent = false;

              if (response.data && response.data.message) {
                ctrl.emailSent = true;
              }
            }
          );

          setTimeout(function () {
            ctrl.emailSent = false;
          }, 3000);
        }
      };
    },
  ],
});
